export const shouldDisplayAnnualPremium = (policyData) =>
  policyData?.premiumSummary?.isAnnual === true && policyData?.capabilities?.showAnnualContractValues === true;

export const getPolicyPremiumDisplay = ({ policyData, valueCoverage, valueService }) => {
  if (shouldDisplayAnnualPremium(policyData)) return policyData.premiumSummary;

  const persistedIof = Number(policyData?.TB_PROPOSAL?.iof || 0);

  return {
    netCoverage: Number(policyData?.isHinova ? policyData?.valueFinal : valueCoverage) - persistedIof,
    iof: persistedIof,
    service: valueService,
    total: Number(policyData?.valueFinal || 0),
  };
};
